import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import InternContainerComponent from './InternContainerComponent';
import twaInternList from './TwaTeam';
import UserInfoContainer from './UserInfoContainer';
import { connect } from 'react-redux';
import store, { cecPageNo, twaPageNo, mbaPageNo, schoolPageNo, collegePageNo } from '../../../redux/store';
// ES6 classNameNameNameName-style
class TWA extends PreLoginSessionCheck {

	constructor(props) {
		super(props);
		this.state = {
			profileData: null,
			userClicked: false
		}
	}

	componentDidMount() {
		this.setState({ profileData: null, userClicked: false });
	}
	hideFn = (profileData) => {
		this.setState({ profileData: profileData, userClicked: true });
	}
	closeFn = () => {
		this.setState({ profileData: null, userClicked: false });
	}

	render() {
		return (
			<div>
				<div className="header">
					<p>Teachers can take time out from their hectic school schedules to reflect on teaching practices and immerse in a totally different and energising learning journey at HeyMath!. Through our Work Attachments, teachers can actively engage with graphic artists, animators, programmers and Math/Science experts - in a highly collaborative and multi-cultural setting - to design interactive tools and lessons that make the learning of Mathematics very exciting for students.</p>
				</div>
				{
					(() => {
						if (this.state.userClicked) {
							return (
								<UserInfoContainer userData={this.state.profileData} closeFn={this.closeFn}></UserInfoContainer>
							)
						} else {
							return (
								<InternContainerComponent getPageValue={this.props.getPageValue} decrementFn={this.props.decrementFn} incrementFn={this.props.incrementFn} profileClickedFn={this.hideFn} internList={twaInternList}></InternContainerComponent>
							)
						}
					})()
				}
			</div>
		);
	}
}

const getStateData = (state) => {
	return {
        getPageValue:()=>{
			//console.log("removeData ");
			return state.twaPageNo
		}
    }
}

const setStateData = (dispatch) => {
	return {
		incrementFn: () => {
			//console.log("addData ",addData);
			dispatch({ type: "twa_pageno_increment" })
		},
		decrementFn: () => {
			//console.log("removeData ");
			dispatch({ type: "twa_pageno_decrement" })
		}
	}
}

export default connect(getStateData, setStateData)(TWA);


// WEBPACK FOOTER //
// ./src/prelogin/src/components/TWA.js